
import "./verifyOTPNewUser.css"
import React, { useState, useEffect } from 'react';
import { Button, Form, Grid, Message } from 'semantic-ui-react';
import { Select, Modal, Space, Typography  } from 'antd';
import axios from "../../api";
import { DownArrowIcon, OTPVerificationSEIcon } from "../../assets";

const { Text, Link, Title } = Typography;

const VerifyOTPNewUser = ({formValues, newUserInfo, termsData, termsAccepted}) => {

    const [enableOTP, setEnableOTP] = useState({});
    const [otpSource, setOTPSource] = useState("Email")
    const [showTimer, setShowTimer] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [timer, setTimer] = useState(60);
    const [OTP, setOTP] = useState('')
    const [disableButton, setDisableButton] = useState(false)
    const { id } = termsData || {};
    
    useEffect(() => {
        let intervalId;
        if (showTimer && timer > 0) {
            intervalId = setInterval(() => {
                setTimer(prevTimer => prevTimer - 1);
            }, 1000);
        } else if (timer == 0) {
            setDisableButton(false)
            setShowTimer(false);
            clearInterval(intervalId);
        }

        return () => clearInterval(intervalId);
    }, [showTimer, timer]);

    const handleChange = (value) => {
        setOTPSource(value)
    }

    const sendOTP = async () => {
        try{
            setDisableButton(true)
            let payload = {
                username: formValues.username
            }
            if(otpSource === "Email")
                payload = {...payload, isEmailVerified: false}
            else
                payload = {...payload, isPhoneVerified: false}
            const response = await axios.post("/users/generateVerifyOtp", {...payload});
            if (response.status === 200 && response.data.otp_sent){
                setEnableOTP({success: 'OTP sent successfully'});
                setTimer(60); 
                setShowTimer(true)
            }
            else{
                setEnableOTP({
                    error: `Unable to generate OTP.`
                });
                setDisableButton(false)
            }
        } catch(e){
            console.log(e);
            setDisableButton(false)
            setEnableOTP({
                error: e?.message || `Unable to generate OTP.`
            });
        }
    };

    const handleOTPInput = (e) => {
        if(e.target.value.length < 7){
            setOTP(e.target.value)
        }
    }

    const onFinishOTP = async () => {
        try{
            let payload = {
                username: formValues.username,
                password: formValues.newPassword,
                is_accepted: termsAccepted,
                terms_and_conditions: id && id.toString()
            };
            if(otpSource === "Email")
                payload = {...payload, email_otp: OTP}
            else
                payload = {...payload, phone_otp: OTP}
            // return
            const response = await axios.post("/users/validatePasswordReset", {...payload});
            if (response.status === 200 && response.data.password_reset) {
                setShowModal(true)
            } 
        } catch (error) {
            if (error && error.error && error.error.message) {
                // setErrorMsg(error.error.message);
                setEnableOTP({
                    error: error.error.message
                });
            } else if(error && error.message) {
                // setErrorMsg(error.message);
                setEnableOTP({
                    error: error.message || `Invalid code, please try again.`
                });
            }
        }
    };

    const getOTPFormFields = () => {
        return <>
            <div className='otp-container'>
            {
                enableOTP.error && <Message negative className="negative-message">
                    <Message.Header>{enableOTP.error}</Message.Header>
                </Message>
            }
            {
                enableOTP.success && <Message success className="negative-message success-message">
                    <Message.Header>{enableOTP.success}</Message.Header>
                </Message>
            }
                <div className='otp-source-container'>
                    <Select
                        suffixIcon={<DownArrowIcon />}
                        defaultValue={otpSource}
                        className='otp-source-dropdown'
                        onChange={handleChange}
                        options={newUserInfo["isPhoneVerified"] ? [
                            {
                                value: 'Email',
                                label: 'Email',
                            },
                            {
                                value: 'Phone',
                                label: 'Phone',
                            },
                        ]: [{
                            value: 'Email',
                            label: 'Email',
                        }]}
                    />
                    <Button className={'otp-source-generate-btn'} onClick={sendOTP} style={disableButton ? {opacity: '0.4', pointerEvents: 'none'} : {opacity: '1'}}>
                        Send OTP
                    </Button>
                </div>
                <div>
                    <Form.Input fluid iconPosition='left' placeholder='Enter OTP' className='code-input-area'
                        name="OTP" value={OTP} onChange={handleOTPInput} />
                </div>
                <div className="resend-otp-new-user-page">
                    { showTimer && <span>If you didn't receive OTP,  <span className={"additional-trigger-timer-count"}>retry in {timer} sec.</span> </span>}
                </div>
                <div className='submit-otp-container'>
                    <Button className={(OTP && OTP.length === 6) ? 'submit-login' : 'submit-login disable-submit-login'} type="primary" htmlType="submit" onClick={onFinishOTP}>
                        Next
                    </Button>
                </div>
            </div>
        </>
    }

    return(
        <div className='login-form'>
            <Grid textAlign='center' style={{height: '100%', display: 'flex'}} verticalAlign='middle'>
                <Grid.Column className={"login-form-container"}>
                    <div className={"login-instruction cs-title"}>
                        <OTPVerificationSEIcon className='otp-page-icon'/>
                        VERIFY YOUR IDENTITY
                    </div>
                        {getOTPFormFields()}
                    {/* {errorMsg && (
                        <div className="verify-otp-new-user-error-container">
                            <Title level={5} type="danger">
                                {errorMsg}
                            </Title>
                        </div>
                    )} */}
                </Grid.Column>
            </Grid>
            <Modal
                centered={true}
                footer={null}
                closable={false}
                open={showModal}
                className="otp-section-modal"
                width={380}
            >
                <Space direction={"vertical"} className="reset-modal-space">
                    <Title level={3} className="reset-modal-title">
                        Your password has been reset!
                    </Title>
                    <Text color="#707070" className="reset-modal-sub-title">
                        {
                            "To ensure your account's security, you will need to log in to the dashboard with your updated credentials."
                        }
                    </Text>
                </Space>
            </Modal>
        </div>
    )
}

export default VerifyOTPNewUser;